/* Cart extras (Theme settings > Cart extras). The kit (assets/kit.js) serializes every cart change and calls sync()
   after each one.
   - shipping_protection: one line, drawn as a checkbox row instead of a cart line. Ticked by default unless the
     setting says otherwise; the buyer's choice is kept in the cart attribute mz_shipping_protection (on / off).
   - add-ons: the slots addon_1 ... addon_6, each a product in one of two styles:
     · card: a card with a variant picker (when the product has variants) and an add button ("Dorzuć kolejną kiść za
       69 zł"). Once added it is an ordinary cart line without a quantity stepper.
     · checkbox: a checkbox row like shipping protection; its cart line is hidden and drawn as the row. "Ticked by
       default" adds it once with the first real item unless the buyer unticked it; the buyer's choice is kept in
       the cart attribute mz_addon_<n> (on / off).
     A slot's title and hint: its settings, else the product's metafields cart.upsell_title (__PRICE__ is replaced
     with its price) and cart.upsell_hint. Its price is always the product's.
     · per_piece ("One per bunch"): the add-on goes with every bunch. Its card adds as many as there are real bunches
       in the cart and says so ("do każdego pudełka: 2 × 9,90 zł").
     · on_product: the slot is also a switch under the product page's offer cards (snippets/product-addons.liquid);
       assets/theme.js sends the ticked ones with the product, as add-on lines. The cart offers the ones not in it.
   Rules: every extra leaves the cart together with the last real item; at most one of each per cart (a per-piece
   add-on: from one up to the number of real bunches, the items that are neither extras nor the kit's gift); a variant
   is never two extras. Add-on lines carry the property _mz_addon: 'upsell', the protection line 'shipping_protection'.
   - next set (stepup, Cart extras > Next set in the cart): while the cart holds fewer pieces of the set product than
     its biggest set, a card on top of the add-on cards offers one more piece in a colour the buyer picks (one not in
     the cart first), priced as the step to the next set: its pieces at full price minus that set's discount, minus
     the cart's set now. It goes in as an ordinary line, so the automatic set discount prices it at checkout. */
(function () {
  'use strict';
  var el = document.getElementById('CartAddonsConfig');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  var prot = cfg.shipping_protection || {};
  var t = cfg.t || {};
  var kitGift = null;
  try { kitGift = JSON.parse(document.getElementById('KitConfig').textContent).gift; } catch (e) { kitGift = null; }
  var giftVariant = kitGift && kitGift.enabled && kitGift.variant != null ? String(kitGift.variant) : null;

  if (!prot.variant || prot.variant === giftVariant) prot.enabled = false;
  prot.attr = 'mz_shipping_protection';
  prot.ticked = prot.ticked !== false;
  // a variant is never two things at once (protection, an add-on, the kit's free gift)
  var upsellOf = {};   // variant id -> its add-on
  var upsells = (cfg.upsells || []).map(function (u) {
    u.variants = (u.variants || []).filter(function (v) { return v.available && v.id !== prot.variant && v.id !== giftVariant && !upsellOf[v.id]; });
    u.variants.forEach(function (v) { upsellOf[v.id] = u; });
    u.picked = u.variants.length ? u.variants[0].id : null;
    u.row = u.style === 'checkbox';   // a checkbox row; else a card
    u.attr = 'mz_' + u.slot;
    u.ticked = !!(u.row && u.ticked);
    return u;
  }).filter(function (u) { return u.variants.length; });

  var step = cfg.stepup && cfg.stepup.variants ? cfg.stepup : null;
  if (step) {
    step.product = String(step.product);
    var fxRate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var fxCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'PLN';
    var fxStep = new Intl.NumberFormat('en', { style: 'currency', currency: fxCurrency }).resolvedOptions().maximumFractionDigits === 0 ? 100 : 1;
    Object.keys(step.offs || {}).forEach(function(qty) { step.offs[qty] = Math.round(step.offs[qty] * fxRate / fxStep) * fxStep; });
    step.variants = step.variants.filter(function (v) { return v.available && !upsellOf[v.id] && v.id !== prot.variant && v.id !== giftVariant; });
    step.words = (step.words || []).map(function (w) { return String(w).trim(); });
    step.picked = null;   // the buyer's pick; else the first colour not in the cart
    if (!step.variants.length) step = null;
  }

  var cart = null;
  var busy = false;
  var error = '';

  function kindOf(item) {
    if (!item) return;
    var p = item.properties || {};
    if (p._kit_gift) return;
    if (p._mz_addon === 'shipping_protection' || p._mz_addon === 'upsell') return p._mz_addon;
    var id = String(item.variant_id);
    if (prot.variant && id === prot.variant) return 'shipping_protection';
    if (upsellOf[id]) return 'upsell';
  }
  // the add-on a cart line belongs to (by its variant), when it is one
  function addonOf(item) { return kindOf(item) === 'upsell' ? upsellOf[String(item.variant_id)] : null; }
  // a line drawn as a checkbox row, never as a cart line
  function isHidden(item) {
    if (kindOf(item) === 'shipping_protection') return true;
    var u = addonOf(item);
    return !!(u && u.row);
  }
  function hasReal(c) {
    return (c.items || []).some(function (item) { return !kindOf(item) && !(item.properties && item.properties._kit_gift); });
  }
  // the real bunches in the cart: the items that are neither extras nor the kit's gift, their quantities summed
  function bunches(c) {
    return ((c && c.items) || []).reduce(function (n, item) {
      return n + (!kindOf(item) && !(item.properties && item.properties._kit_gift) ? item.quantity : 0);
    }, 0);
  }
  // a checkbox extra (x: the protection or a checkbox add-on): the buyer's choice, else its default; one already in
  // the cart stays until the buyer unticks it
  function wants(c, x, inCart) {
    var choice = (c.attributes || {})[x.attr];
    if (choice === 'on') return true;
    if (choice === 'off') return false;
    return !!(x.ticked || inCart);
  }
  function money(cents) {
    if (window.__kit && window.__kit.money) return window.__kit.money(cents);
    return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: window.shopCurrency || 'PLN' }).format(cents / 100);
  }

  // Bring the extras in line with the cart: resolves to { cart, changed }
  async function sync(c, post, getCart) {
    var updates = {};
    var additions = [];
    var items = c.items || [];
    var real = hasReal(c);
    var pieces = bunches(c);
    var protIn = items.some(function (item) { return kindOf(item) === 'shipping_protection'; });
    var want = real && prot.enabled && wants(c, prot, protIn);
    var kept = false;
    var keptUpsell = {};
    items.forEach(function (item) {
      var kind = kindOf(item);
      var quantity = item.quantity;
      if (kind === 'shipping_protection') {
        quantity = want && !kept && String(item.variant_id) === prot.variant ? 1 : 0;
        if (quantity) kept = true;
      } else if (kind === 'upsell') {
        var u = upsellOf[String(item.variant_id)];
        var keep = real && u && !keptUpsell[u.handle] && (!u.row || wants(c, u, true));
        // one per cart; a per-piece add-on: from one up to the number of real bunches
        quantity = !keep ? 0 : u.per_piece ? Math.min(Math.max(item.quantity, 1), pieces) : 1;
        if (quantity) keptUpsell[u.handle] = true;
      }
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (want && !kept) additions.push({ id: prot.variant, quantity: 1, properties: { _mz_addon: 'shipping_protection' } });
    // a checkbox add-on the buyer ticked, or one ticked by default, comes with the first real item
    upsells.forEach(function (u) {
      if (u.row && real && !keptUpsell[u.handle] && wants(c, u, false)) additions.push({ id: u.picked, quantity: u.per_piece ? pieces : 1, properties: { _mz_addon: 'upsell' } });
    });
    var changed = Object.keys(updates).length > 0 || additions.length > 0;
    if (Object.keys(updates).length) await post('cart/update.js', { updates: updates });
    if (additions.length) await post('cart/add.js', { items: additions });
    return { cart: changed ? await getCart() : c, changed: changed };
  }

  function node(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  // an add-on's title, with its badge (a small shield or gift) before it
  function titled(tag, cls, u) {
    var n = node(tag, cls);
    if (u.badge === 'shield' || u.badge === 'gift') {
      var mark = node('span', 'cart-addon__mark cart-addon__mark--' + u.badge);
      mark.setAttribute('aria-hidden', 'true');
      n.appendChild(mark);
    }
    n.appendChild(document.createTextNode(u.title || ''));
    return n;
  }
  // "do każdego pudełka: 2 × 9,90 zł": what a per-piece add-on's card adds, one for every real bunch in the cart
  function perPiece(v) {
    return String(t.per_piece || '').replace('__COUNT__', Math.max(1, bunches(cart))).replace('__PRICE__', function () { return money(v.price); });
  }
  function upsellCard(u) {
    var v = u.variants.find(function (x) { return x.id === u.picked; }) || u.variants[0];
    var card = node('div', 'cart-upsell');
    card.setAttribute('data-cart-upsell', u.handle);
    var src = u.image || v.image;
    if (src) {
      var img = node('img', 'cart-upsell__img');
      img.src = src; img.alt = ''; img.width = 72; img.height = 72; img.loading = 'lazy';
      card.appendChild(img);
    }
    var body = node('div', 'cart-upsell__body');
    body.appendChild(titled('p', 'cart-upsell__title', u));
    if (u.hint) body.appendChild(node('p', 'cart-upsell__hint', u.hint));
    if (u.per_piece && t.per_piece) {
      var each = node('p', 'cart-upsell__hint', perPiece(v));
      each.setAttribute('data-cart-upsell-per-piece', '');
      body.appendChild(each);
    }
    var row = node('div', 'cart-upsell__row');
    if (u.variants.length > 1) {
      var select = node('select', 'cart-upsell__select');
      select.setAttribute('aria-label', u.option || t.variant || 'Wariant');
      select.setAttribute('data-cart-upsell-variant', '');
      u.variants.forEach(function (x) {
        var o = node('option', '', x.title);
        o.value = x.id; if (x.id === v.id) o.selected = true;
        select.appendChild(o);
      });
      select.disabled = busy;
      row.appendChild(select);
    }
    var btn = node('button', 'btn btn--secondary cart-upsell__btn', t.add || 'Dodaj');
    btn.type = 'button'; btn.setAttribute('data-cart-upsell-add', ''); btn.disabled = busy;
    row.appendChild(btn); body.appendChild(row); card.appendChild(body);
    return card;
  }
  // the set product's pieces in the cart (not extras, not the kit's gift)
  function setPieces(c) {
    return ((c && c.items) || []).reduce(function (n, item) {
      return n + (step && String(item.product_id) === step.product && !kindOf(item) && !(item.properties && item.properties._kit_gift) ? item.quantity : 0);
    }, 0);
  }
  function stepPick(c) {
    var ids = ((c && c.items) || []).map(function (item) { return String(item.variant_id); });
    if (step.picked && step.variants.some(function (v) { return v.id === step.picked; })) return step.picked;
    var fresh = step.variants.find(function (v) { return ids.indexOf(v.id) < 0; });
    return (fresh || step.variants[0]).id;
  }
  // "Dodaj drugi ogrzewacz za 100,00 zł": the step from the cart's set to the next one, or nothing
  function stepCard(c) {
    if (!step) return null;
    var n = setPieces(c);
    var next = n + 1;
    if (n < 1 || next > step.max || step.offs[String(next)] == null) return null;
    var picked = stepPick(c);
    var v = step.variants.find(function (x) { return x.id === picked; });
    var off = function (k) { return step.offs[String(k)] || 0; };
    var add = v.price * next - off(next) - (v.price * n - off(n));
    if (add <= 0) return null;
    var card = node('div', 'cart-upsell cart-upsell--step');
    card.setAttribute('data-cart-stepup', '');
    if (v.image) {
      var img = node('img', 'cart-upsell__img');
      img.src = v.image; img.alt = ''; img.width = 72; img.height = 72; img.loading = 'lazy';
      card.appendChild(img);
    }
    var body = node('div', 'cart-upsell__body');
    body.appendChild(node('p', 'cart-upsell__title', String(step.title || '').replace('__NTH__', step.words[next - 2] || next + '.').replace('__PRICE__', money(add))));
    var hint = String(step.hint || '').replace('__TOTAL__', money(v.price * next - off(next))).replace('__REGULAR__', money(v.price * next));
    var threshold = (window.__kit && window.__kit.cfg && window.__kit.cfg.ship && window.__kit.cfg.ship.threshold) || 0;
    if (threshold && step.free && c.total_price < threshold && c.total_price + add >= threshold) hint += ' ' + step.free;
    if (hint) body.appendChild(node('p', 'cart-upsell__hint', hint));
    var row = node('div', 'cart-upsell__row');
    if (step.variants.length > 1) {
      var select = node('select', 'cart-upsell__select');
      select.setAttribute('aria-label', t.variant || 'Wariant');
      select.setAttribute('data-cart-stepup-variant', '');
      step.variants.forEach(function (x) {
        var o = node('option', '', x.title);
        o.value = x.id; if (x.id === picked) o.selected = true;
        select.appendChild(o);
      });
      select.disabled = busy;
      row.appendChild(select);
    }
    var btn = node('button', 'btn btn--primary cart-upsell__btn', t.add || 'Dodaj');
    btn.type = 'button'; btn.setAttribute('data-cart-stepup-add', picked); btn.disabled = busy;
    row.appendChild(btn); body.appendChild(row); card.appendChild(body);
    return card;
  }

  function checkbox(name, checked) {
    var input = node('input');
    input.type = 'checkbox'; input.setAttribute('data-cart-addon', name);
    input.checked = checked;
    input.disabled = busy;
    return input;
  }
  function protectionRow(line, c) {
    var label = node('label', 'cart-addon');
    label.appendChild(checkbox('shipping_protection', error ? wants(c, prot, !!line) : !!line));
    if (prot.badge !== 'none') {
      var icon = node('span', prot.badge === 'gift' ? 'cart-addon__gift' : 'cart-addon__shield'); icon.setAttribute('aria-hidden', 'true');
      label.appendChild(icon);
    }
    var text = node('span', 'cart-addon__text');
    text.appendChild(node('span', 'cart-addon__label', prot.label));
    if (prot.hint) text.appendChild(node('span', 'cart-addon__hint', prot.hint));
    label.append(text, node('span', 'cart-addon__price', money(line ? line.final_line_price : prot.price)));
    return label;
  }
  // a checkbox-style add-on: the same row, with the product's picture
  function addonRow(u, line, c) {
    var v = u.variants[0];
    var label = node('label', 'cart-addon cart-addon--extra');
    label.appendChild(checkbox(u.slot, error ? wants(c, u, !!line) : !!line));
    var src = u.image || v.image;
    if (src) {
      var img = node('img', 'cart-addon__img');
      img.src = src; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy';
      label.appendChild(img);
    }
    var text = node('span', 'cart-addon__text');
    text.appendChild(titled('span', 'cart-addon__label', u));
    if (u.hint) text.appendChild(node('span', 'cart-addon__hint', u.hint));
    label.append(text, node('span', 'cart-addon__price', money(line ? line.final_line_price : v.price * (u.per_piece ? Math.max(1, bunches(c)) : 1))));
    return label;
  }

  function render(c) {
    cart = c;
    var real = hasReal(c);
    var protLine = (c.items || []).find(function (item) { return kindOf(item) === 'shipping_protection'; });
    var lineOf = {};   // an add-on's handle -> its cart line
    (c.items || []).forEach(function (item) { var u = upsellOf[String(item.variant_id)]; if (u && !lineOf[u.handle]) lineOf[u.handle] = item; });
    document.querySelectorAll('[data-cart-addons]').forEach(function (host) {
      var part = host.getAttribute('data-part') || 'all';
      host.replaceChildren();
      // an uncrowded cart: the next card(s) only, in slot order (Theme settings > Cart extras > Cards shown at once);
      // when one is added, the next one takes its place
      if (real && part !== 'protection') {
        var shown = 0, most = cfg.max_cards > 0 ? cfg.max_cards : 1;
        var next = stepCard(c);
        if (next) { host.appendChild(next); shown++; }
        upsells.forEach(function (u) { if (!u.row && !lineOf[u.handle] && shown < most) { host.appendChild(upsellCard(u)); shown++; } });
      }
      // the checkbox rows stay together: the checkbox add-ons, then shipping protection
      if (real && part !== 'upsells') {
        upsells.forEach(function (u) { if (u.row) host.appendChild(addonRow(u, lineOf[u.handle], c)); });
        if (prot.enabled) host.appendChild(protectionRow(protLine, c));
      }
      if (error && host.childElementCount) {
        var message = node('p', 'cart-addons__error', error); message.setAttribute('role', 'alert');
        host.appendChild(message);
      }
      host.hidden = !host.childElementCount;
    });
    document.querySelectorAll('[data-cart-error]').forEach(function (message) { message.hidden = !error; message.textContent = error; });
    // The full cart page keeps its native inputs for the no-JS fallback; a checkbox extra's line shows as its row.
    document.querySelectorAll('[data-cart-item-key]').forEach(function (row) {
      var item = (c.items || []).find(function (it) { return it.key === row.dataset.cartItemKey; });
      row.hidden = !!(item && isHidden(item));
    });
  }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('[name="checkout"]').forEach(function (button) { button.disabled = value; });
    if (cart) render(cart);
  }
  function settle() { if (document.querySelector('.cart-page__form')) location.reload(); }

  document.addEventListener('change', function (event) {
    var stepSelect = event.target.closest('[data-cart-stepup-variant]');
    if (stepSelect && step) {
      step.picked = stepSelect.value;
      if (cart) render(cart);
      return;
    }
    var select = event.target.closest('[data-cart-upsell-variant]');
    if (select) {
      var u = upsellOf[select.value];
      if (!u) return;
      u.picked = select.value;
      var chosen = u.variants.find(function (x) { return x.id === u.picked; });
      // the same product's card in the other cart view follows
      document.querySelectorAll('[data-cart-upsell="' + u.handle + '"]').forEach(function (card) {
        var img = card.querySelector('.cart-upsell__img');
        // a picture set in the theme editor stays; else the card shows the picked variant's photo
        if (img && chosen && chosen.image && !u.image) img.src = chosen.image;
        var each = card.querySelector('[data-cart-upsell-per-piece]');
        if (each && chosen) each.textContent = perPiece(chosen);
        var other = card.querySelector('[data-cart-upsell-variant]');
        if (other && other !== select) other.value = u.picked;
      });
      return;
    }
    var input = event.target.closest('[data-cart-addon]');
    if (!input || busy) return;
    // the checkbox's extra: shipping protection, or a checkbox add-on (addon_<n>)
    var name = input.getAttribute('data-cart-addon');
    var extra = name === 'shipping_protection' ? prot : upsells.find(function (x) { return x.row && x.slot === name; });
    if (!extra) return;
    var attributes = {};
    attributes[extra.attr] = input.checked ? 'on' : 'off';
    error = ''; setBusy(true);
    fetch(cfg.root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
      .then(function (c) { render(c); settle(); })
      .catch(function () { error = cfg.error; })
      .finally(function () { setBusy(false); });
  });
  document.addEventListener('click', function (event) {
    var stepBtn = event.target.closest('[data-cart-stepup-add]');
    if (stepBtn && step) {
      if (busy) return;
      error = ''; setBusy(true);
      fetch(cfg.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: stepBtn.getAttribute('data-cart-stepup-add'), quantity: 1 }] })
      }).then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
        .then(function () { step.picked = null; settle(); })
        .catch(function () { error = cfg.error; })
        .finally(function () { setBusy(false); });
      return;
    }
    var btn = event.target.closest('[data-cart-upsell-add]');
    var card = btn && btn.closest('[data-cart-upsell]');
    var u = card && upsells.find(function (x) { return x.handle === card.getAttribute('data-cart-upsell'); });
    if (!u || busy || !u.picked) return;
    error = ''; setBusy(true);
    fetch(cfg.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // a per-piece add-on: one for every real bunch in the cart
      body: JSON.stringify({ items: [{ id: u.picked, quantity: u.per_piece ? Math.max(1, bunches(cart)) : 1, properties: { _mz_addon: 'upsell' } }] })
    }).then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
      .then(settle)
      .catch(function () { error = cfg.error; })
      .finally(function () { setBusy(false); });
  });
  document.addEventListener('kit:cart', function (event) { render(event.detail); });

  // The product page's switches (snippets/product-addons.liquid): a row stays only while its variant is its own
  // slot's add-on here, so a variant is never two extras on the product page either
  function checkSwitches() {
    document.querySelectorAll('[data-product-addons]').forEach(function (host) {
      host.querySelectorAll('[data-product-addon]').forEach(function (input) {
        var u = upsellOf[input.getAttribute('data-variant')];
        if (u && u.handle === input.getAttribute('data-product-addon')) return;
        (input.closest('label') || input).remove();
      });
      if (!host.querySelector('[data-product-addon]')) host.hidden = true;
    });
  }
  checkSwitches();
  document.addEventListener('shopify:section:load', checkSwitches);

  window.themeAddons = {
    sync: sync, render: render, setBusy: setBusy,
    isAddon: kindOf,
    // a checkbox extra (the protection, a checkbox add-on) is drawn as its row, never as a cart line
    isHidden: isHidden,
    fail: function () { error = cfg.error; if (cart) render(cart); }
  };
})();
